export const mergeDefined = (target, source) => {
  if (!target || !source) return target
  Object.keys(source).forEach((key) => {
    if (source[key] !== null && source[key] !== undefined) {
      target[key] = source[key]
    }
  })
  return target
}
